<script>
    import app from "../stores/app";
    import {createEventDispatcher} from 'svelte/internal';
    import {initializeApp, deleteApp} from "Firebase/app";
    import {
        getFirestore,
        collection,
        doc,
        // getDocs,
        query,
        // where,
        updateDoc,
        onSnapshot,

    } from "Firebase/firestore";
    import {formatDate} from "../lib/lib";

    let firebaseConfig = null;
    let frBase = null;
    let db = null;
    let appChannelUnsubscribe = null;
    let taxiChannelUnsubscribe = null;

    const dispatch = createEventDispatcher();

    export const initialize = () => {
        if (!$app.firebaseConfig) {
            console.log("no firebase configuration");
            return;
        }
        if (frBase != null) {
            console.log("firebase already initialized");
            return;
        }

        frBase = initializeApp($app.firebaseConfig);
        db = getFirestore(frBase);
        console.log("firebase connected");
    }

    export const close = () => {
        if (frBase == null) {
            console.log("firebase already closed");
            return;
        }
        deleteApp(frBase);
        frBase = null;
        console.log("firebase disconnected");
    }

    export const openAppChannel = () => {
        const q = query(collection(db, "app_channel"));
        appChannelUnsubscribe = onSnapshot(q, (snapshot) => {
            snapshot.docChanges().forEach((change) => {
                if (change.type === "modified") {
                    dispatch("app_channel", change.doc.data());
                }
            });
        });
        console.log("app channel opened");
    }

    export const closeAppChannel = () => {
        if (appChannelUnsubscribe == null) {
            console.log("locals channel already closed");
            return;
        }

        appChannelUnsubscribe();
        appChannelUnsubscribe = null;
        console.log("app channel closed");
    }

    export const openTaxisChannel = () => {
        const q = query(collection(db, "taxi_channel"));
        taxiChannelUnsubscribe = onSnapshot(q, (snapshot) => {
            snapshot.docChanges().forEach((change) => {
                if (change.type === "modified") {
                    console.log("TAXI RESPONSE!");
                    dispatch("taxi_channel", change.doc.data());
                }
            });
        });
        console.log("taxis channel opened");
    }

    export const closeTaxisChannel = () => {
        if (taxiChannelUnsubscribe == null) {
            console.log("taxis channel already closed");
            return;
        }

        taxiChannelUnsubscribe();
        taxiChannelUnsubscribe = null;
        console.log("taxis channel closed");
    }

    export const assignLocalToTaxi = (local) => {

        if (frBase == null) {
            console.log("firebase is closed");
            return;
        }

        let message = "";
        if (local.taxi) {
            message += "Taxi: " + local.taxi.taxi_number;
        }
        if (local.driver) {
            message += " - " + local.driver.name;
        }

        let data = {
            taxi_id: local.taxi_id,
            status_id: local.status_id,
            title: "Local Transfer Assignment",
            message,
            datetime: formatDate(new Date(), 'y-m-d H:i:s'),
        }

        const docRef = doc(db, 'taxi_channel', 'notification');
        updateDoc(docRef, data)
            .then(docRef => {
                console.log("taxi_channel modified");
            })
            .catch(error => {
                console.log(error);
            });
    }


    export const updateLocalTransfer = (local) => {
        let data = {
            id: local.id,
            type: 2,
            user_id: local.user_id,
            operator_id: local.operator_id,
            edited_by: local.edited_by,
            transporter_id: local.transporter_id,
            taxi_id: local.taxi_id,
            status_id: local.status_id,
            data: '',
            datetime: formatDate(new Date(), 'y-m-d H:i:s'),
        }

        const docRef = doc(db, 'app_channel', 'transfer');
        updateDoc(docRef, data)
            .then(docRef => {
                console.log("app_channel modified");
            })
            .catch(error => {
                console.log(error);
            });
    }


    const enableNotifications = () => {
        if (window.Notification) {
            Notification.requestPermission(status => {
                if (status === 'granted') {
                } else {
                }
            });
        }
    }


    if ('PushManager' in window) {
        if (window.Notification) {
            if (Notification.permission === 'denied') {
                enableNotifications();
            }
        }
    }
</script>